import StatCard from "pages/dashboard-overview/components/StatCard";
import StatCardSkeleton from "pages/analytics/components/StatCardSkeleton";
import { ErrorBanner } from "pages/analytics/components/AnalyticsStates";
import { formatNumber, formatPercent } from "pages/analytics/components/analyticsFormatters";

const formatCurrency = (value) =>
  `$${Number(value ?? 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}`;

export default function GhlPipelineKpiCards({ data, isLoading, error, compact = false }) {
  const cardCount = compact ? 3 : 6;
  const gridClass = compact
    ? "grid grid-cols-3 gap-3 mb-4"
    : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6";

  if (isLoading) {
    return (
      <div className={gridClass}>
        {[...Array(cardCount)].map((_, i) => (
          <StatCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className={compact ? "mb-4" : "mb-6"}>
        <ErrorBanner message={error} />
      </div>
    );
  }

  const cards = [
    <StatCard key="booked" title="Calls Booked" value={formatNumber(data?.callsBooked)} icon="Calendar" />,
    <StatCard key="showed" title="Calls Showed" value={formatNumber(data?.callsShowed)} icon="CheckCircle" />,
    <StatCard key="closed" title="Deals Closed" value={formatNumber(data?.dealsClosed)} icon="Award" />,
    <StatCard key="noshow" title="No-Show Rate" value={formatPercent(data?.noShowRate)} icon="UserX" />,
    <StatCard key="close" title="Close Rate" value={formatPercent(data?.closeRate)} icon="Target" />,
    <StatCard
      key="pipeline"
      title="Pipeline Value"
      value={formatCurrency(data?.pipelineValue)}
      icon="DollarSign"
    />,
  ];

  return (
    <div className={gridClass}>
      {cards.slice(0, cardCount)}
    </div>
  );
}
